import { LOOK as B2C_LOOK } from "../b2c/look";

/**
 * B2B video look. Same brand roles as the B2C video (so the two read as
 * one family on the landing), plus the dashboard surfaces the partner
 * page shows. Scenes never hardcode colors; they pick a role here.
 */
export const LOOK = {
  ...B2C_LOOK,
  /** Dashboard window chrome (the partner page's blue title bar). */
  chrome: B2C_LOOK.blue,
  /** Card panel inside a dashboard. */
  panel: B2C_LOOK.bg2,
} as const;

export { FLOAT_SHADOW } from "../b2c/look";

/**
 * Type scale on the 1080-short-side stage. The landing shows the
 * landscape cut ~900px wide (≈0.47×) and LinkedIn shows the feed cut
 * ~390pt wide (≈0.36×), so nothing important goes below `support`.
 * `label` (step kickers) and `legal` (sources, disclaimers) are the floor:
 * ~13pt and ~10pt on a phone, the smallest that still reads.
 */
export const TYPE = {
  hero: 120,
  headline: { wide: 88, square: 74, tall: 82 },
  support: 42,
  label: 36,
  legal: 28,
} as const;
